module.exports = __webpack_public_path__ + "img/teacat_img_waiting.9a36fdd2.png";